module.exports = __webpack_public_path__ + "assets/favicons/manifest.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/manifest.json
// module id = 1240
// module chunks = 1